import { useInactiveLoyaltyDiscount } from '../useInactiveLoyaltyDiscount';
import { useInactiveVolumeDiscounts } from '../useInactiveVolumeDiscounts';
import { useInactiveDistinctProductsDiscount } from '../useInactiveDistinctProductsDiscount';
import type { MappedDiscount } from '~~/types/discounts';

export const useInactiveDiscounts = () => {

  const { inactiveLoyaltyDiscount } = useInactiveLoyaltyDiscount();
  const { inactiveVolumeDiscounts } = useInactiveVolumeDiscounts();
  const { inactiveDistinctProductsDiscount } = useInactiveDistinctProductsDiscount();

  const inactiveDiscounts = computed<MappedDiscount[]>(() => {

    const discounts: MappedDiscount[] = [];

    if (inactiveLoyaltyDiscount.value) {

      discounts.push(inactiveLoyaltyDiscount.value);
    
    }

    discounts.push(...inactiveVolumeDiscounts.value);

    if (inactiveDistinctProductsDiscount.value) {

      discounts.push(inactiveDistinctProductsDiscount.value);
    
    }

    return discounts;
  
  });

  return {
    inactiveDiscounts,
  };

};
